export default () => {
  const write = (text) => navigator.clipboard.writeText(text)

  const read = async () => navigator.clipboard.readText()

  return [write, read]
}
